// removed by extract-text-webpack-plugin
module.exports = {"InfoSection":"DibsItForm__-loca-__2KFYq","Spinner":"DibsItForm__-loca-__SYVKt","HowItWorksLink":"DibsItForm__-loca-__3rW4e","SubmitSection":"DibsItForm__-loca-__NMGfy","SocialMediaField":"DibsItForm__-loca-__29VcU","SubmitButton":"DibsItForm__-loca-__21-lL"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DibsItForm/DibsItForm.css
// module id = 155
// module chunks = 0